const getters = {
    access_token: state => state.user.access_token,
    userInfo: state => state.user.userInfo,
    refresh_token: state => state.user.refresh_token,
    expires_in: state => state.user.expires_in,
    cart: state => state.user.cart,
    city_code: state => state.user.city_code,
    city_name: state => state.user.city_name,
    address: state => state.user.address,
    orderInfo: state => state.order.orderInfo,
    visibleTabBar: state => state.user.visibleTabBar,
    mall_module: state => state.user.mall_module
}

export default getters
